<template>
  <v-timeline-item color="grey" icon-color="grey lighten-2" small>
    <component :is="type == logtypes.text ? 'v-card' : 'div'" class="px-3">
      <v-row no-gutters justify="space-between">
        <v-col cols="auto" class="d-flex flex-column py-1">
          <small> {{ i18nFormatDateTime(item.TimeStamp) }}</small>
          <UserChip v-if="item.User" :user="item.User" :index="0" :typecolored="true">
          </UserChip>
          <span v-else>{{ item.UserDisplayName }}</span>
        </v-col>
        <v-col v-if="type == logtypes.text" cols="0" class="py-1 pl-3">
          <small style="white-space: pre-line">{{ item.Text }}</small>
        </v-col>
        <v-col v-else-if="type == logtypes.statuschange" cols="0" class="py-1 pl-3">
          <v-row no-gutters>
            <v-col v-if="oldStatus" cols="5" style="opacity: 0.6;">
              <v-card :color="statuscolor(oldStatus.Id)" class="px-1" :class="oldSubstatus ? 'rounded-b-0' : ''" dark>
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <v-icon size="13" class="mr-1">{{ oldStatus.icon }}</v-icon>
                  </v-col>
                  <v-col cols="0" class="nowrapheader">
                    <small>{{ oldStatus.Name }}</small>
                  </v-col>
                </v-row>
              </v-card>
              <v-card v-if="oldSubstatus" :color="statuscolor(oldStatus.Id)"
                style="background-image: linear-gradient(rgb(0 0 0/27%) 0 0);" class="px-1 rounded-t-0" dark>
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <v-icon size="12" class="mr-1">mdi-folder</v-icon>
                  </v-col>
                  <v-col cols="0" class="nowrapheader">
                    <small>{{ oldSubstatus.Name }}</small>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="auto" align-self="center">
              <v-icon class="mx-1">mdi-chevron-right</v-icon>
            </v-col>
            <v-col cols="5" v-if="newStatus">
              <v-card :color="statuscolor(newStatus.Id)" class="px-1" :class="newSubstatus ? 'rounded-b-0' : ''" dark>
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <v-icon size="13" class="mr-1">{{ newStatus.icon }}</v-icon>
                  </v-col>
                  <v-col cols="0" class="nowrapheader">
                    <small>{{ newStatus.Name }}</small>
                  </v-col>
                </v-row>
              </v-card>
              <v-card v-if="newSubstatus" :color="statuscolor(newStatus.Id)"
                style="background-image: linear-gradient(rgb(0 0 0/27%) 0 0);" class="px-1 rounded-t-0" dark>
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <v-icon size="12" class="mr-1">mdi-folder</v-icon>
                  </v-col>
                  <v-col cols="0" class="nowrapheader">
                    <small>{{ newSubstatus.Name }}</small>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </component>
  </v-timeline-item>
</template>


<script>
import UserChip from "@/components/Buttons/UserChip.vue";


export default {
  name: "JobLoggTimelineItem",
  props: {
    item: Object,
    statuses: Array,
    substatuses: Array,
  },
  components: {
    UserChip,
  },
  mixins: [],

  data() {
    return {
      logtypes: {
        text: "text",
        statuschange: "statuschange",
      },
      type: "text",
      oldStatus: null,
      oldSubstatus: null,
      newStatus: null,
      newSubstatus: null,
    };
  },

  mounted() {

    this.findLogType();
  },

  methods: {
    findLogType() {
      if (this.item.Text.startsWith("JobStatus changed from ")) {
        this.parseStatuses()
        this.type = this.logtypes.statuschange;
      }
    },

    parseStatuses() {
      var arr = this.item.Text.split("'")

      this.separateOutStatusAndSubstatus(arr[3], 'newStatus', 'newSubstatus');
      this.separateOutStatusAndSubstatus(arr[1], 'oldStatus', 'oldSubstatus');
    },

    separateOutStatusAndSubstatus(combo, statuskey, substatuskey) {
      var statusId = combo.split('/')[0];
      this[statuskey] = this.statuses.find(x => x.Id == statusId);
      var substatusId = combo.split('/')[1];
      this[substatuskey] = this.substatuses.find(x => x.Id == substatusId);
      //console.log(combo, this[statuskey], this[substatuskey]);
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>